<template>
  <div class="wrap">
    <div class="profile profile-1 flex flex-vc">
      <div class="avatar">
        <img
          :src="userInfo.avatar ? userInfo.avatar : defaultAvatar"
          @click="(_) => (this.show = !this.show)"
        />
        <van-image-preview
          v-model="show"
          :images="[userInfo.avatar || defaultAvatar]"
          v-show="userInfo.avatar"
        />
      </div>
      <div class="info flex-1">
        <div class="name">
          <div>{{ userId ? userInfo.name : "访客" }}</div>
        </div>
        <div class="phone flex flex-vc" style="lineheight: 50px">
          <div v-if="!isEdit">
            {{ userInfo.mobile }}
          </div>
          <input
            class="phoneIpt"
            maxlength="11"
            ref="tt"
            v-else
            @input="inputMsg"
            placeholder="输入手机号"
            v-model="userInfo.mobile"
            @blur="changeMsg"
          />
          <span v-if="errmsg" class="errmsg">手机号格式有误</span>
        </div>
        <div v-if="userInfo.deptName" style="fontSize: 20px">
          <div>{{ userInfo.deptName }}</div>
        </div>
      </div>
      <div>
        <!-- <van-icon :name="iconName" @click="iconChange(isEdit)" /> -->
        <el-button
          v-if="!userId"
          size="medium"
          :type="btnValue == '保存' ? 'primary' : ''"
          style="
            transform: scale(0.7);
            font-size: 1.5rem;
            padding: 0.5rem 0.8rem;
          "
          @click="iconChange(isEdit)"
          >{{ btnValue }}</el-button
        >
      </div>
    </div>

    <!-- <div
      class="profile profile-2" 
    >
      <div class="title">个人信息</div>
      <div class="list-info">
        <div class="item flex flex-b flex-vc">
          <div class="left flex flex-vc">
            <img src="@/assets/images/m10.png" alt="" />
            <span>姓名 : {{ userInfo.name }}</span>
          </div>
        </div>
        <div class="item flex flex-b flex-vc">
          <div class="left flex flex-vc">
            <img src="@/assets/images/m9.png" alt="" />
            <span>{{ userInfo.deptName }}</span>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="profile profile-2" v-if="userInfo">
      <div class="title" style="fontSize: 18px">核酸检测信息</div>
      <div class="list-info">
        <div class="item flex flex-b flex-vc">
          <div class="left flex flex-vc">
            <img src="@/assets/images/m13.png" alt="" />
            <span style="fontSize: 18px">最近一次核酸检测时间</span>
          </div>
          <div class="right">
            <span style="fontSize: 18px">{{ time || "暂无数据" }}</span></div>
        </div>
      </div>
    </div> -->

    <!-- 核酸检测信息 -->
    <div
      class="no_info"
      v-if="userId"
      :style="{ backgroundColor: isRed ? '#e61317' : '#0C810F' }"
    >
      <div
        class="no_info_title"
        :style="{ backgroundColor: isRed ? '#af0920' : '#55C257' }"
      >
        <div>核酸检测信息</div>
        <div class="no_info_tishi">(仅显示校内最近两次核酸检测时间)</div>
      </div>
      <div class="no_info_date">
        <div class="today_date">{{ time || "暂无数据" }}</div>
        <div class="prev_data" v-if="prevTime">{{ prevTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import imgTrue from "@/assets/images/m12.png";
import imgFalse from "@/assets/images/m11.png";
import avatar from "@/assets/images/avatar方.png";
import moment from "moment";
import axios from "axios";
import { Dialog } from "vant";
export default {
  data() {
    return {
      defaultAvatar: avatar,
      isEdit: false,
      show: false,
      // iconName: "edit",
      btnValue: "编辑",
      userInfo: {},
      classList: [],
      vipData: [],
      imgIcon: [imgTrue, imgFalse, imgTrue],
      phoneChanged: false,
      errmsg: false,
      personType: "",

      // 核酸检测信息
      naInfo: {},
      prevTime: "",
      time: "",
      userId: JSON.parse(localStorage.getItem('userInfo')).id,
      // 核酸信息显示颜色
      isRed: true,
    };
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // console.log(this.userInfo);
    if (!this.userInfo.mobile || this.userInfo.mobile === "") {
      this.isEdit = true;
      this.btnValue = "保存";
      Dialog.alert({
        title: "温馨提示",
        message: "请编辑手机号并点击保存,进行身份绑定",
      }).then(() => {
        this.$nextTick(() => {
          this.$refs.tt.focus();
        });
      });
    }
    this.getClassInfo();
    this.getVipData();
  },
  watch: {
    "userInfo.mobile": function (value) {
      this.phoneChanged =
        value != JSON.parse(localStorage.getItem("userInfo")).mobile;
    }
  },
  created() {
    if (JSON.parse(localStorage.getItem("userInfo")).id) {
      this.userId = JSON.parse(localStorage.getItem("userInfo")).id;
      this.getNaInfo();
    }
  },
  methods: {
    async getSchoolList() {
      const { code, data } = await this.$https.getSchoolList({
        // userId: this.$store.state.userId,
      });
      // console.log("信息", data);
      if (code !== 200) {
        this.list = [];
        return false;
      }
      let obj = {
        13: "老师",
        12: "家长",
        2: "访客",
      };
      if (data.patriarchList.length + data.teacherList.length === 1) {
        if (data.patriarchList.length > 0) {
          this.personType = 12;
          console.log('我是家长开始进入选择角色了');
          this.identitySwitch(data.patriarchList[0].id);
        } else if (data.teacherList.length > 0) {
          this.personType = 13;
          console.log('我是老师开始进入选择角色了');
          this.identitySwitch(data.teacherList[0].id);
        } else {
          
          this.personType = "访客";
          location.reload()
        }
      } else {
        setTimeout(() => {
          this.$router.push({
            name: "schoolSwitch",
            params: { hrefTo: true },
          });
        }, 500);
      }
    },
    async getNaInfo() {
      this.userId = JSON.parse(localStorage.getItem("userInfo")).id;
      this.axios
        .get(`student-consumer/detect/getLastOneByUserId`, {
          params: {
            userId: JSON.parse(localStorage.getItem("userInfo")).id,
          },
        })
        .then((res) => {
          if (res.code === 200) {
            console.log("res", res);
            this.naInfo = res.data;

           
            this.time = res.data[0] && moment(res.data[0].detectDate).format("MM月DD日");
            this.prevTime =res.data[1] && moment(res.data[1].detectDate).format(
              "MM月DD日"
            );

            // this.prevTime= moment(res.data[1].detectDate).format('MM月DD日')
            // 48小时日期
            let twoTime = moment(
              new Date().getTime() - 24 * 2 * 60 * 60 * 1000
            ).format("YYYY-MM-DD");
            // 一周
            let weekTime = moment(
              new Date().getTime() - 7 * 24 * 60 * 60 * 1000
            ).format("YYYY-MM-DD");
            // 24小时
            let oneTime = moment(
              new Date().getTime() - 24 * 60 * 60 * 1000
            ).format("YYYY-MM-DD");

            if (this.userInfo.deptName == "高暴露人群") {
              this.isRed = moment(
                moment(res.data[0].detectDate).format("YYYY-MM-DD")
              ).isBefore(oneTime);
            } else if (this.userInfo.deptName == "教职工") {
              
              this.isRed = moment(
                moment(res.data[0].detectDate).format("YYYY-MM-DD")
              ).isBefore(weekTime);
            } else {
              if (
                moment(
                  moment(res.data[0].detectDate).format("YYYY-MM-DD")
                ).isBefore(twoTime)
              ) {
                // 颜色变为红色
                this.isRed = true;
              } else {
                // 颜色变为绿色
                this.isRed = false;
              }
            }
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // 本地测试请求

      //  本地测试
    },
    async identitySwitch(id) {
      const { data, code } = await this.$https.identitySwitch({
        openId: JSON.parse(localStorage.getItem("userInfo")).openId,
        userId: id,
        userType: this.personType == 13 ? "1" : "2",
      });
      // return
      if (code !== 200) {
        return;
      }
      // console.log('选中角色了，重新执行查询');
      // console.log(data);

      this.$store.commit("setUserId", data.id);
      this.$store.commit("setSchoolId", data.schoolId);
      localStorage.setItem("userInfo", JSON.stringify(data));
      this.getNaInfo();
      this.getClassInfo();
      this.getVipData();
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    },







    // inputMsg () {
    //   if () {

    //   }
    // },

    changeMsg() {
      
      let reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      this.errmsg = !reg.test(this.userInfo.mobile);
    },
    VipTime(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    hrefVip(value) {
      // console.log(value);
      this.$router.push({
        name: "openvip",
        params: value,
      });
    },
    iconChange(type) {
      if (!type) {
        this.isEdit = !type;
        // this.iconName = type ? "edit" : "passed";、
        this.btnValue = type ? "编辑" : "保存";
        this.$nextTick(() => {
          this.$refs.tt.focus();
        });
      } else {
        //格式进来进入保存
        if (!this.errmsg) {
          this.isEdit = !type;
          // this.iconName = type ? "edit" : "passed";
          this.btnValue = type ? "编辑" : "保存";
          let userInfo = { ...this.userInfo };
          delete userInfo.idNumber;
          this.axios
            .post("student-consumer/api/user/updateTpdUser", userInfo)
            .then((res) => {
              if (res.code === 200) {
                console.log('res.data',res.data)
                if (res.data) {
                  let info = JSON.parse(localStorage.getItem("userInfo"));
                  localStorage.setItem(
                    "userInfo",
                    JSON.stringify({
                      ...info,
                      ...res.data,
                    })
                  );
                }
                this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
                this.getSchoolList();

                // setTimeout(() => {
                //   this.$router.push({
                //     name: "schoolSwitch",
                //     params: { hrefTo: true },
                //   });
                // },500)
              } else {
                this.$toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$toast("服务器错误，请联系管理员");
            });
        }
      }
    },
    async getClassInfo() {
      this.axios
        .get("student-consumer/api/user/getTeacherByPhone", {
          params: {
            mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.classList = res.data;
          } else {
            this.$toast("服务器错误，请联系管理员");
          }
        });
    },
    async getVipData() {
      const { code, data } = await this.$https.getParentsPayAuthChildrenList({
        mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
      });
      if (code !== 200 || !data) {
        return;
      }
      this.$store.commit("setVipData", data);
      this.childRadio = data[0].id;
      this.vipData = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 15px;
  .profile {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 15px;
    color: #1a1a1a;
  }
}
.profile-1 {
  padding: 10px;
  padding-right: 0px;
  position: relative;
  .avatar {
    width: 120px;
    height: 150px;
    margin-right: 17px;
    border-radius: 8px;
    overflow: hidden;
  }
  .info {
    position: relative;
    // margin-right: 20px;
    //
    .name {
      margin-bottom: 8px;
      color: #1a1a1a;
      font-size: 30px;
    }
    .phone {
      font-size: 20px;
      color: #000;
      height: 50px;
      div {
        height: 16px;
        line-height: 16px;
      }
    }
  }
  // .icon {
  //   position: absolute;
  //   right: 45px;
  //   width: 17px;
  //   height: 17px;
  //   top: 18px;
  // }
  .input {
    border: none;
  }
  // .ninput {
  //   line-height: 21px;
  // }
}
.profile-2 {
  img {
    width: 15px;
    height: 15px;
    margin-right: 13px;
  }
  .list-info {
    .item {
      padding: 8px 15px;
      font-size: 13px;
      .left {
        color: #666666;
      }
      .right {
        // width: 65%;
        display: flex;
        flex-wrap: wrap;
        span {
          margin-right: 8px;
        }
      }
    }
  }
}
.profile-3 {
  .child-list {
    .item {
      padding: 5px 23px 10px 23px;
      /* margin: 10px 0; */
      font-size: 13px;
      .i-1 {
        margin-right: 12px;
        width: 25%;
        display: flex;
        span {
          height: 15px;
          display: inline-block;
        }
        img {
          width: 14px;
          height: 14px;
          margin-left: 6px;
          margin-top: 1px;
          float: right;
        }
      }
      .i-2 {
        span:first-child {
          margin-right: 10px;
        }
        .i-2-bottom {
          font-size: 12px;
          margin-top: 6px;
          color: #666666;
          span {
            margin-left: 5px;
          }
        }
      }
    }
  }
}
.title {
  padding: 12px 25px;
  position: relative;
  font-size: 15px;
  color: #1a1a1a;

  &::before {
    content: "";
    position: absolute;
    left: 15px;
    height: 13px;
    width: 3px;
    background: #37a5da;
    top: 16px;
  }
}
img {
  width: 100%;
  height: 100%;
}
.phoneIpt {
  padding: 0;
  font-size: 20px;
  width: 8rem;
  outline: none;
  border: none;
  height: 25px;
  line-height: 18px;
}
.errmsg {
  position: absolute;
  bottom: -15px;
  left: 45px;
  color: red;
  font-size: 12px;
  transform: scale(0.8);
}
.no_info {
  padding-top: 10px;
  padding-bottom: 20px;
  border-radius: 8px;
  .no_info_title {
    color: #fff;
    margin: 0 10px 10px;
    border-radius: 5px;
    padding: 0 10px;
    line-height: 25px;
    .no_info_tishi {
      font-size: 14px;
    }
  }
  .no_info_date {
    background-color: #fff;
    margin: 0 10px 0;
    border-radius: 10px;
    padding: 5px 0;
    .prev_data {
      text-align: center;
      font-size: 30px;
      color: #000;
      line-height: 50px;
    }
    .today_date {
      text-align: center;
      font-size: 45px;
      line-height: 50px;
      color: #000;
    }
  }
}
</style>
